import ResourcePage from "@/components/common/ResourcePage";

export default function IndustryPacksPage() {
  return (
    <ResourcePage
      title="Industry Packs" subtitle="Additive vertical entitlement bundles"
      base="/v1/industry-packs" perm="INDUSTRY_PACK"
      columns={[
        { key: "packCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.packCode}</span> },
        { key: "packName", header: "Name" },
        { key: "compatiblePlanCodes", header: "Compatible Plans", render: (r) => (r.compatiblePlanCodes || []).join(", ") },
        { key: "status", header: "Status" },
      ]}
      fields={[
        { name: "packCode", label: "Pack Code", immutable: true },
        { name: "packName", label: "Pack Name" },
        { name: "description", label: "Description" },
        { name: "compatiblePlanCodes", label: "Compatible Plan Codes", type: "tags", placeholder: "DIAMOND, ENTERPRISE" },
        { name: "extraFeatureCodes", label: "Extra Feature Codes", type: "tags" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      ]}
    />
  );
}
